import { render, staticRenderFns } from "./BaseNavigationTabs2.vue?vue&type=template&id=60728fb3&lang=pug"
import script from "./BaseNavigationTabs2.vue?vue&type=script&lang=js"
export * from "./BaseNavigationTabs2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60728fb3')) {
      api.createRecord('60728fb3', component.options)
    } else {
      api.reload('60728fb3', component.options)
    }
    module.hot.accept("./BaseNavigationTabs2.vue?vue&type=template&id=60728fb3&lang=pug", function () {
      api.rerender('60728fb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/BaseNavigationTabs2.vue"
export default component.exports